module.exports = __webpack_public_path__ + "static/media/025.87af5309.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/025.jpg
// module id = 372
// module chunks = 0